import * as actionTypes from '../constants/actionsType';

export const accNoAdd = (data) => {
    return {
        type: actionTypes.STORE_ACCNO,
        payload: data
    }
}